export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'What grades does Math Ready cover?',
    answer: 'All of them — a complete workbook for each grade, 1 through 10.',
  },
  {
    question: 'Is it aligned to a curriculum?',
    answer:
      'Yes. Every unit is aligned and tagged to the US Common Core State Standards for Mathematics (CCSS-Math).',
  },
  {
    question: 'What format are the volumes in?',
    answer: 'Clean, print-ready digital files you can print or use on screen.',
  },
  {
    question: 'How do I get it after I buy?',
    answer: 'Instantly — you’ll get a download link right after checkout.',
  },
  {
    question: 'Can I use it for a whole class or multiple children?',
    answer: 'Yes, it’s built for teachers, tutors, and parents to use with their own students.',
  },
  {
    question: 'Do I need a strong math background to teach it?',
    answer:
      'No. Every lesson includes worked examples, step-by-step guidance, and full answer keys, so you can teach it confidently.',
  },
  { question: 'Is there a refund policy?', answer: 'Yes — a 30-day money-back guarantee, no questions asked.' },
]
